import { formatLocationTag, createLocationTagsFromString } from '@/core';
import deepCopy from 'deepcopy';

function setDateFrom({ commit }, date) {
	commit('updateSearchFilterDate', { key: 'etd', isFrom: true, date });
}
function setDateTo({ commit }, date) {
	commit('updateSearchFilterDate', { key: 'etd', isFrom: false, date });
}


function addFromLocation({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'fromLocation', tag: formatLocationTag(tag) });
}
function addFromLocationString({ commit }, value) {
	commit('appendSearchFilterTagList', { key: 'fromLocation', tags: createLocationTagsFromString(value) });
}
function setFromLocation({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'fromLocation', tagList: tagList.map(tag => formatLocationTag(tag)) });
}


function addToLocation({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'toLocation', tag: formatLocationTag(tag) });
}
function addToLocationString({ commit }, value) {
	commit('appendSearchFilterTagList', { key: 'toLocation', tags: createLocationTagsFromString(value) });
}
function setToLocation({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'toLocation', tagList: tagList.map(tag => formatLocationTag(tag)) });
}


function addStatus({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'status', tag });
}

function setStatuses({ commit }, value) {
	commit('setSearchFilterItem', { key: 'status', value });
}


function addTripType({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'tripType', tag });
}

function setTripType({ commit }, value) {
	commit('setSearchFilterItem', { key: 'tripType', value });
}


function addCargoCarrier({ commit }, tag) {
	tag.type = 'id';
	commit('addSearchFilterTagList', { key: 'cargoCarrier', tag });
}
function addCargoCarrierString({ commit }, value) {
	commit('addSearchFilterTagList', { key: 'cargoCarrier', tag:{ id: value, description: value, type: 'text' } });
}
function setCargoCarrier({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'cargoCarrier', tagList });
}

function addInputTagsOnSearch({ commit }, inputs) {
	if (inputs.fromLocation)
		commit('appendSearchFilterTagList', { key: 'fromLocation', tags: createLocationTagsFromString(inputs.fromLocation,) });
	if (inputs.toLocation)
		commit('appendSearchFilterTagList', { key: 'toLocation', tags: createLocationTagsFromString(inputs.toLocation,) });
	if (inputs.cargoCarrier)
		commit('addSearchFilterTagList', { key: 'cargoCarrier', tag:{ id:inputs.cargoCarrier,name:inputs.cargoCarrier } });
}

function changeTagOpCode({ commit }, { key, tag }) {
	let tagCopy = deepCopy(tag);
	if (!tagCopy.op || tagCopy.op === 'OR') {
		tagCopy.op = 'AND';
		tagCopy.color = 'green';
	} else if (tagCopy.op === 'AND') {
		tagCopy.op = 'NOT';
		tagCopy.color = 'red';
	} else if (tagCopy.op === 'NOT') {
		tagCopy.op = 'OR';
		tagCopy.color = 'blue';
	}
	commit('updateSearchFilterTag', { key, tag: tagCopy });
}

function changeTagOpCodeBetweenNotAndOr({ commit }, { key, tag }) {
	let tagCopy = deepCopy(tag);
	if (tagCopy.op && tagCopy.op === 'NOT') {
		tagCopy.op = 'OR';
		tagCopy.color = 'blue';
	} else {
		tagCopy.op = 'NOT';
		tagCopy.color = 'red';
	}
	commit('updateSearchFilterTag', { key, tag: tagCopy });
}

export default {
	setDateFrom,
	setDateTo,
	addFromLocation,
	addFromLocationString,
	setFromLocation,
	addToLocation,
	addToLocationString,
	setToLocation,
	addStatus,
	setStatuses,
	addTripType,
	setTripType,
	addCargoCarrier,
	addCargoCarrierString,
	setCargoCarrier,
	addInputTagsOnSearch,
	changeTagOpCode,
	changeTagOpCodeBetweenNotAndOr,
};
